import { createContext } from 'react';
import type { MeResponse } from '../../entities/me/me-contract.types';
import type { StaffLoginPayload, StaffLoginResult } from '../../entities/me/me.api';
import type { ApiClient } from '../api/api-client';
import type { StaffBootstrapState } from '../bootstrap/bootstrap-state';

export type StaffAuthMeRefreshOptions = {
  /**
   * Только JWT superadmin: GET `/auth/me?organization_id=0` — эффективная орг. в ответе `null`
   * (сброс контекста в staff после «Без контекста организации»).
   */
  superadminClearEffectiveOrg?: boolean;
};

export type AuthContextValue = {
  me: MeResponse | null;
  impersonateOrgId: number | null;
  fetchError: string | null;
  bootstrapState: StaffBootstrapState;
  /** HTTP-клиент с тем же транспортом авторизации, что и bootstrap `/auth/me`. */
  apiClient: ApiClient;
  /** Вход по паролю: токены сразу или требование выбрать раздел (`context_required`). */
  login: (payload: StaffLoginPayload) => Promise<StaffLoginResult | void>;
  /** После успешного GET /auth/call-status (вход по звонку): сначала `/auth/me`, затем коммит токенов. */
  applySessionTokens: (accessToken: string, refreshToken: string | null) => void | Promise<void>;
  logout: () => void;
  /** Возвращает актуальный `me` после GET `/auth/me` или `null` при ошибке/401. */
  refreshMe: (opts?: StaffAuthMeRefreshOptions) => Promise<MeResponse | null>;
  setImpersonateOrgId: (organizationId: number | null) => Promise<void>;
};

export const AuthContext = createContext<AuthContextValue | null>(null);
